import axios from 'axios'
import { BASE_URL } from './config'
import { getAccessToken, clearAuthData } from '@/utils/authUtils'
import { toast } from 'sonner'
import ROUTES from '@/routes/routes'

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
})
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getAccessToken()

    // List of paths that should not have a token attached
    const noAuthPaths = [
      '/auth/dj-rest-auth/login/',
      '/auth/dj-rest-auth/registration/',
      '/auth/dj-rest-auth/registration/verify-email/',
      '/auth/dj-rest-auth/logout/',
      '/auth/forgot-password/',
      '/auth/dj-rest-auth/password/reset/confirm/',
      '/auth/setup-2fa/',
    ]

    const shouldSkipAuth = noAuthPaths.some((path) =>
      config.url?.includes(path)
    )

    if (token && config.headers && !shouldSkipAuth) {
      config.headers.Authorization = `Bearer ${token}`
    }

    return config
  },
  (error) => Promise.reject(error)
)

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response?.status === 401 &&
      error.response?.data?.code === 'token_not_valid' &&
      localStorage.getItem('token')
    ) {
      toast.error('Your session has expired. Please log in again.', {
        duration: 3000,
      })

      clearAuthData()

      setTimeout(() => {
        window.location.href = ROUTES.LOGIN
      }, 1500)
    }
    return Promise.reject(error)
  }
)

export default axiosInstance
